import { fetchApi } from '@/config/axiosSetting';
import {
  SubstitutionPartsListParams,
  SubstitutionPartsListResponse,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getSubstitutionPartsList/getSubstitutionPartsListQuery.type';

export const getInitialVisitSubstitutionPartsListQueryFunction = (
  params: SubstitutionPartsListParams,
): Promise<SubstitutionPartsListResponse> =>
  fetchApi.get(`/initial/reports/${params.id}/accessory/`);
